import stripeConnectedAccountListStore from '@modules/stripe/stripe-connected-account/stripe-connected-account-list-store';
import stripeConnectedAccountViewStore from '@modules/stripe/stripe-connected-account/stripe-connected-account-view-store';
import stripeConnectedAccountFormStore from '@modules/stripe/stripe-connected-account/stripe-connected-account-form-store';

export default {
  namespaced: true,

  modules: {
    form: stripeConnectedAccountFormStore,
    list: stripeConnectedAccountListStore,
    view: stripeConnectedAccountViewStore
  },
};
